export default __webpack_public_path__ + "static/media/becareful.a6d5beb9.svg";